// ═══════════════════════════════════════════════════════════════════════════
//  examsApi.js — capa de datos del EXAMEN DE NIVEL (Fase 3)
//
//  Habla con /api/v3/exams: el alumno presenta un examen CONCRETO (definido en
//  el CRM), distinto del examen de colocación de /api/v3/assessment.
//
//  ⚠️  El navegador NUNCA recibe la clave de respuesta. El servidor sirve un
//      reactivo a la vez y califica él. Esta capa solo transporta.
// ═══════════════════════════════════════════════════════════════════════════
const BASE = `${import.meta.env.VITE_API_URL || ''}/api/v3/exams`;

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, { headers: authHeaders(), ...options });
  if (!res.ok) {
    let detail = 'No pudimos conectar con el examen.';
    try {
      const body = await res.json();
      if (body?.detail) detail = body.detail;
    } catch { /* respuesta sin JSON: mensaje genérico */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export function listExams() {
  return request('');
}

export function examDetail(code) {
  return request(`/${encodeURIComponent(code)}`);
}

export function startExam(code) {
  return request(`/${encodeURIComponent(code)}/start`, { method: 'POST' });
}

export function answerExam({ sessionId, itemId, response, timeMs }) {
  return request('/answer', {
    method: 'POST',
    body: JSON.stringify({
      session_id: sessionId, item_id: itemId, response, time_ms: timeMs,
    }),
  });
}

export function examResult(sessionId) {
  return request(`/result/${sessionId}`);
}
